<template>
	<div>

    <!--
    <template v-if="parseInt(match.geniusId) > 0 && typeof match.rid === 'undefined'">
      <iframe :src="'https://interbettab.betstream.betgenius.com/betstream-view/page/betgenius/footballscorecentre?eventId='+match.geniusId" style="border: 0;" scrolling="no" width="100%" height="300"/>
    </template>

    <<template v-if="match.rid > 0">
      <iframe :src="'/static/room.html?matchId='+matchId" style="border: 0" width="100%" height="415" scrolling="no"/>
    </template> !-->

    <iframe v-if="!match.rid && match.providerId === 2" :src="'https://visualization.ml.bcua.io/'+match.extendedId+'?provider=5&score=true&team_names=true&partner=425&lang=tur&timer=true&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55X25hbWUiOiJiZXRjb25zdHJ1Y3RfZGV2IiwiaXNzIjoibWxwcm94eSIsInNwb3J0IjpbImFsbCJdLCJmZWVkX3R5cGUiOlsiYWxsIl0sInByb3ZpZGVycyI6WyJhbGwiXX0.XrRZDu-SYt4yOKTuW8_8XoF5Y0R8K5wPsSvh01g5-d0&lang='+window.userLang" style="border: 0" width="100%" height="230" scrolling="no"/>

    <iframe v-if="match.rid > 0" style="background: white; border: 0" :src="'/static/tracker.html?collapse=disable&layout=single&board=enable&matchId='+match.rid+'&layout=single&lang='+window.userLang.substring(0, 2)" width="100%" height="345" scrolling="no"/>


    <div id="sr_widget"></div>

  </div>
</template>

<script>
    export default {
        name: "scoreboard",
	    props: {
            matchId: {
                default: 0
            },
            match: {

            },
            collapseTo: {
                    type: String,
              default: 'disable'
            },
            layout: {
                type: String,
                default: 'single'
            },
	    },
      data () {
          return {
            window: window
          }
      },
	    watch: {
            'matchId' () {
              SIR("removeWidget", "#sr-widget");
              if(this.match.rid > 0){
                this.sportWidget()
              }
            }
	    },
		  beforeDestroy () {
			SIR("removeWidget", "#sr-widget");

	    },
	    mounted () {

          if(this.match.rid > 0)
            	this.sportWidget()

	    },
	    methods:{
            sportWidget(){
                //SIR("addWidget", "#sr_widget", "match.lmtPlus", {showOdds:false,adsFrequency:false,collapseTo: this.collapseTo,layout: this.layout, detailedScoreboard: "disable", language: window.userLang, matchId: this.matchId});
            }
	    }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/widget/scoreboard.vue